export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-cyrillic-ext-400-normal.woff2?fd1478dcc74de00ee4c0568d64101892";